export default __webpack_public_path__ + "static/media/Avelsia.3767d147.png";